import React, { useState } from "react";
import Button from "olive-react-myoneui/lib/Button";
import SampleImage2 from "../../../assets/images/sample2.jpg";
import Rate from "../../../components/Rate";
import IconDesc from "../my-course/IconDesc";
import { bookIcon, boxOIcon, checkCircleIcon , playIcon, closeIcon, externalLink} from "../../../constants/icons";
import Container from "olive-react-myoneui/lib/Container";
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";

function CourseDetailsHeader({className}) {
  const [rating, setRating] = useState("");
  const [modal, setModal] = useState(false);
  const [videoLoading, setVideoLoading] = useState(true);
  console.log(rating,typeof rating,"rating")
  const openModal = () => {
    setModal(!modal);
  };

  const closeModal = () => {
    setModal(!modal);
  };

  const spinner = () => {
    setVideoLoading(!videoLoading);
  };

  const round = (args) => {
    return Math.round(args)
  }

  return (
    <div className={`${className || ""} course-inner-header`} >
      <Container>
        <Row className="align-items-center">
          <Col lg={8}>
            <div className="course-description">
              <h1>The Complete Python Masterclass : Become a Python Engineer</h1>
              <p className="mb-1">Learn A-Z everything about Python, from the basics, to advanced topics like Python GUI, Python Data Analysis, and more!</p>
              <div className="rating-wrapper d-flex align-items-center gap-1 my-3">
              <div className="start-wrap">
                  <p className="mb-0">{round(rating)}</p>
                  <Rate
                    rating={rating}
                    count={5}
                    onRating={(rate) => setRating(rate)}
                  />
                </div>
              </div>
              <div className="rating-wrapper d-block d-md-flex align-items-center gap-3 mb-3 mt-1">
                <IconDesc
                  icon={bookIcon}
                  paraDesc="Instructed by"
                  linkDesc="Gokul"
                  link="#"
                  className="mb-1 mb-md-0"
                />
                <IconDesc
                  icon={checkCircleIcon}
                  paraDesc="Expiring on 29/07/2023"
                  className="mb-1 mb-md-0"
                />
                <IconDesc
                  icon={boxOIcon}
                  paraDesc="3 Courses"
                  className="mb-1 mb-md-0"
                />
              </div>
            </div>
          </Col>
          <Col lg={4}>
            <div className="course-image-wrapper">
              <img src={SampleImage2} className="img-fluid" alt="Course Image" />
              <div onClick={openModal} className="btn-play">
                {playIcon}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      {modal ? (
        <section className="modal__bg">
          <div className="modal__align">
            <div className="modal__content" modal={modal}>
              <div
                className="modal__close"
                arial-label="Close modal"
                onClick={closeModal}>
                  {closeIcon} Close
              </div>
              <div className="modal__video-align">
                {videoLoading ? (
                  <div className="modal__spinner">
                    <div
                      className="modal__spinner-style"
                      fadeIn="none">
                        {externalLink}
                    </div>
                  </div>
                ) : null}
                <iframe
                  className="modal__video-style"
                  onLoad={spinner}
                  loading="lazy"
                  width="800"
                  height="500"
                  src="https://www.youtube.com/embed/4UZrsTqkcW4"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
        </section>
      ) : null}
    </div>
  );
}

export default CourseDetailsHeader;
